<template>
	<el-dialog class="reportDialog" :visible="show" append-to-body @close="handleClose"
		@open="isClose = false;getFanSi()">
		<div slot="title">
			<div class="dislogTitle">
				群成员（2/2）
			</div>
		</div>
		<div class="dislogConent">
			<div class="fanList">
				<div class="fans" v-for="(item,index) in fanSiData" :key="index" @click="item.check = !item.check">
					<div class="left">
						<img class="avatar" :src="item.user.avatar" v-if="item.user && item.user.avatar" />
						<img class="avatar" src="../assets/defaultAvatar.png" />
						{{item.user && item.user.user_nickname ? item.user.user_nickname : ''}}
					</div>
					<img class="checkIcon" src="../assets/MyOrder/iconA.png" v-if="item.check" />
					<img class="checkIcon" src="../assets/MyOrder/iconE.png" v-else />
				</div>
			</div>
		</div>
		<div slot="footer">
			<div class="menuBox">
				<el-button class="stepNext" type="primary" size="medium" @click="nextStep">上一步</el-button>
				<el-button class="submit" type="primary" size="medium" @click="submitForm()">立即创建</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			data: {
				type: Object,
				default: () => {},
			}
		},
		data() {
			return {
				isClose: false,
				fanSiData: [],
			}
		},
		methods: {
			handleClose() {
				this.$emit('close', this.isClose)
			},
			getFanSi() {
				this.$api.post('/Hua/fensi', {
					p: 1,
					type: 1,
					pagesize: 999,
				}).then(res => {
					if (res.code == 1) {
						res.data.list.forEach(item => {
							this.fanSiData.push({
								...item,
								check: false
							})
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
			nextStep() {
				this.isClose = true
				this.handleClose()
			},
			submitForm() {
				const userIds = this.fanSiData.filter(item => item.check).map(item => item.user_id)
				if (userIds.length == 0) {
					return this.$message.warning('请添加群成员')
				}
				this.$api.post('/Liaotian/create_group', {
					...this.data,
				}).then(res => {
					if (res.code == 1) {
						if (res.code == 1) {
							this.$api.post('/Liaotian/add_group_user', {
								user_id: userIds.join(','),
								gid: res.data
							}).then(result => {
								if (result.code == 1) {
									this.$emit('createSuc')
								} else {
									this.$message.success(result.msg)
								}
							}).catch(err => {
								console.log(err);
							})
						} else {
							this.$message.success(res.msg)
						}
					}
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.reportDialog {

		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;


				.fanList {
					height: 5rem;
					overflow-y: auto;

					.fans {
						height: .72rem;
						display: flex;
						align-items: center;
						justify-content: space-between;
						border-bottom: .01rem solid #CCCCCC;
						cursor: pointer;

						.left {
							display: flex;
							align-items: center;
							font-size: .16rem;
							color: #161616;
							line-height: .24rem;

							.avatar {
								margin-right: .12rem;
								width: .4rem;
								height: .4rem;
								object-fit: cover;
								border-radius: 50%;
							}
						}

						.checkIcon {
							width: .18rem;
							height: .18rem;
						}
					}
				}

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-textarea {
								&__inner {
									width: 4.1rem;
									padding: .08rem .16rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									border: .01rem solid #EFD8B8;
								}
							}

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.stepNext {
						margin: .32rem .16rem 0;
						width: 1.3rem;
						height: .36rem;
						background: #FFFFFF;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #E29358;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
						border: .01rem solid #E29358;
					}

					.submit {
						margin: .32rem .16rem 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>